/** @fileoverview Renders a compact spinner with an optional loading label. */

import type { ReactNode } from 'react';
import { cn } from 'cn';
import { LoaderCircle } from 'lucide-react';

type Props = {
  children: ReactNode;
  className?: string;
};

export default function LoadingState({ children, className = '' }: Props) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 text-center text-sm text-app-text-muted',
        className
      )}
      role="status"
      aria-live="polite"
    >
      <LoaderCircle className="h-5 w-5 animate-spin text-app-brand-strong" aria-hidden="true" />
      {children}
    </div>
  );
}
